import { useState } from "react";
import { Modal } from "@react-solutions-ui/findmore-ui";
import styles from "./DeleteNoteModal.module.css";
import { deleteEmployeeNote } from "../../../../features/home/services/employeeNotesService";

interface Props {
  employeeId: string;
  noteId: string;
  onClose: () => void;
  onSuccess?: (msg: string) => void;
}

export default function DeleteNoteModal({
  employeeId,
  noteId,
  onClose,
  onSuccess,
}: Props) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteEmployeeNote(employeeId, noteId);
      onSuccess?.("Nota eliminada com sucesso!");
      onClose();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      title="ELIMINAR NOTA"
      type="confirm"
      confirmActionLabel="ELIMINAR"
      closeModalLabel="CANCELAR"
      onConfirmAction={handleDelete}
      onCloseModal={onClose}
      isSending={isDeleting}
      cancelDisabled={isDeleting}
      confirmDisabled={isDeleting}
      redButton
    >
      <p className={styles.message}>
        Tens a certeza de que queres eliminar esta nota?
        <br />
        Esta ação não pode ser anulada.
      </p>
    </Modal>
  );
}
